import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/Hello'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/health/yiji',
      name: 'home',
      component: home
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js